// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { LogManager } from "@lib/logging/LogManager";
import { IEventListener } from "@lib/utilities/IEventListener";

const log = LogManager.createLog("EventListener");

/**
 * Provides methods for registering and dispatching an event.
 * Used as a private member while the `IEventListener` is publicly exposed.
 */
export class EventListener<TFunction extends (...args: any[]) => any> implements IEventListener<TFunction> {
  private readonly functions: TFunction[] = [];

  get dispatch(): TFunction
  {
    return this._dispatch as TFunction;
  }

  addListener(callback: TFunction): void
  {
    this.functions.push(callback);
  }

  clearListeners(): void
  {
    this.functions.splice(0, this.functions.length);
  }

  hasListener(callback: TFunction): boolean
  {
    return this.functions.indexOf(callback) !== -1;
  }

  removeListener(callback: TFunction): void
  {
    const index = this.functions.indexOf(callback);
    if (index !== -1)
    {
      this.functions.splice(index, 1);
    }
  }

  private _dispatch = (...args: any[]) =>
  {
    let result: any = undefined;
    let first = true;
    for (const item of this.functions)
    {
      let callResult = undefined;
      try
      {
        callResult = item.apply(undefined, args);
      }
      catch (ex)
      {
        log.error("Event handler %o failed: %o", item, ex);
      }

      if (first)
      {
        first = false;
        result = callResult;
      }
    }
    return result;
  }
}